<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("bosch.panel") }}
        </label>
        <v-select
          :value="panelFilter"
          :options="panelOptions"
          class="w-100"
          :multiple="false"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:panelFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("alarm.start_date_filter") }}</label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="startDatetime"
          @on-change="(selectedDates, val) => $emit('update:startDatetime', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("alarm.end_date_filter") }}</label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="endDatetime"
          @on-change="(selectedDates, val) => $emit('update:endDatetime', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    flatPickr
  },
  props: {
    panelOptions: {
      type: Array,
    },
    panelFilter: {
      default: null,
    },
    startDatetime: {
      type: String,
      default: null,
    },
    endDatetime: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      localSearchQuery: this.searchQuery
    };
  },
  watch: {
    searchQuery(val) {
      this.localSearchQuery = val;
    },
  },
  methods: {
    updateSearchQuery() {
      this.$emit("update:searchQuery", this.localSearchQuery);
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
